"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Api = exports.HttpClient = exports.FecContentType = exports.CancelReason = exports.Action = exports.CoBrandPartner = exports.FriendlyIdType = exports.SubscriptionStatus = exports.BillingPeriod = exports.SubscriptionVendorType = exports.Currency = exports.OfferItemType = void 0;
var OfferItemType;
(function (OfferItemType) {
    OfferItemType["PRODUCT"] = "PRODUCT";
    OfferItemType["SUPPLEMENT"] = "SUPPLEMENT";
})(OfferItemType = exports.OfferItemType || (exports.OfferItemType = {}));
var Currency;
(function (Currency) {
    Currency["USD"] = "USD";
    Currency["CAD"] = "CAD";
})(Currency = exports.Currency || (exports.Currency = {}));
var SubscriptionVendorType;
(function (SubscriptionVendorType) {
    SubscriptionVendorType["ATLAS"] = "ATLAS";
    SubscriptionVendorType["ISERIES"] = "ISERIES";
    SubscriptionVendorType["PAYPAL"] = "PAYPAL";
})(SubscriptionVendorType = exports.SubscriptionVendorType || (exports.SubscriptionVendorType = {}));
var BillingPeriod;
(function (BillingPeriod) {
    BillingPeriod["DAILY"] = "DAILY";
    BillingPeriod["WEEKLY"] = "WEEKLY";
    BillingPeriod["MONTHLY"] = "MONTHLY";
    BillingPeriod["ANNUAL"] = "ANNUAL";
    BillingPeriod["BIANNUAL"] = "BIANNUAL";
    BillingPeriod["QUARTERLY"] = "QUARTERLY";
    BillingPeriod["PAY_PERIOD"] = "PAY_PERIOD";
})(BillingPeriod = exports.BillingPeriod || (exports.BillingPeriod = {}));
var SubscriptionStatus;
(function (SubscriptionStatus) {
    SubscriptionStatus["ACTIVE"] = "ACTIVE";
    SubscriptionStatus["CANCELLED"] = "CANCELLED";
    SubscriptionStatus["SUSPENDED"] = "SUSPENDED";
    SubscriptionStatus["PRECANCEL"] = "PRECANCEL";
    SubscriptionStatus["PENDING_CANCEL"] = "PENDING_CANCEL";
    SubscriptionStatus["CATCHING_UP"] = "CATCHING_UP";
})(SubscriptionStatus = exports.SubscriptionStatus || (exports.SubscriptionStatus = {}));
var FriendlyIdType;
(function (FriendlyIdType) {
    FriendlyIdType["MEMBER"] = "MEMBER";
    FriendlyIdType["ASSOCIATE"] = "ASSOCIATE";
    FriendlyIdType["OTHER"] = "OTHER";
})(FriendlyIdType = exports.FriendlyIdType || (exports.FriendlyIdType = {}));
var CoBrandPartner;
(function (CoBrandPartner) {
    CoBrandPartner["PRIMERICA"] = "PRIMERICA";
    CoBrandPartner["SOFI"] = "SOFI";
    CoBrandPartner["NEWITY"] = "NEWITY";
})(CoBrandPartner = exports.CoBrandPartner || (exports.CoBrandPartner = {}));
var Action;
(function (Action) {
    Action["CREATED"] = "CREATED";
    Action["UPDATE_OFFERS"] = "UPDATE_OFFERS";
    Action["DELETED"] = "DELETED";
    Action["UPDATED"] = "UPDATED";
    Action["STATUS_CHANGED"] = "STATUS_CHANGED";
    Action["PAYMENT_UPDATED"] = "PAYMENT_UPDATED";
    Action["BILLING_ADVANCED"] = "BILLING_ADVANCED";
    Action["VENDOR_UPDATED"] = "VENDOR_UPDATED";
    Action["FRIENDLYID_UPDATED"] = "FRIENDLYID_UPDATED";
    Action["CHANGE_OWNER"] = "CHANGE_OWNER";
    Action["DO_NOT_REINSTATE_UPDATED"] = "DO_NOT_REINSTATE_UPDATED";
    Action["RETRY_SCHEDULE_UPDATED"] = "RETRY_SCHEDULE_UPDATED";
    Action["ADMINISTRATIVE_AREA_UPDATED"] = "ADMINISTRATIVE_AREA_UPDATED";
    Action["POSTAL_CODE_UPDATED"] = "POSTAL_CODE_UPDATED";
    Action["STARTED_ON_UPDATED"] = "STARTED_ON_UPDATED";
    Action["NEXT_BILL_ON_UPDATED"] = "NEXT_BILL_ON_UPDATED";
    Action["SOURCE_UPDATED"] = "SOURCE_UPDATED";
    Action["BILLING_FREQUENCY_UPDATED"] = "BILLING_FREQUENCY_UPDATED";
    Action["BILL_CYCLE_DAY_UPDATED"] = "BILL_CYCLE_DAY_UPDATED";
    Action["BILLING_DIVISION_UPDATED"] = "BILLING_DIVISION_UPDATED";
})(Action = exports.Action || (exports.Action = {}));
var CancelReason;
(function (CancelReason) {
    CancelReason["NO_LONGER_EMPLOYED"] = "NO_LONGER_EMPLOYED";
    CancelReason["LEAVE_OF_ABSENCE"] = "LEAVE_OF_ABSENCE";
    CancelReason["MEMBER_REQUESTED_CANCEL"] = "MEMBER_REQUESTED_CANCEL";
    CancelReason["DECEASED"] = "DECEASED";
})(CancelReason = exports.CancelReason || (exports.CancelReason = {}));
const axios_1 = __importDefault(require("axios"));
const utils_1 = require("../../utils");
var FecContentType;
(function (FecContentType) {
    FecContentType["Json"] = "application/json";
    FecContentType["FormData"] = "multipart/form-data";
    FecContentType["UrlEncoded"] = "application/x-www-form-urlencoded";
})(FecContentType = exports.FecContentType || (exports.FecContentType = {}));
class HttpClient {
    constructor(_a = {}) {
        var { securityWorker, secure, format } = _a, axiosConfig = __rest(_a, ["securityWorker", "secure", "format"]);
        this.securityData = null;
        this.setSecurityData = (data) => {
            this.securityData = data;
        };
        this.request = (_b) => __awaiter(this, void 0, void 0, function* () {
            var { secure, path, type, query, format, body } = _b, params = __rest(_b, ["secure", "path", "type", "query", "format", "body"]);
            const secureParams = ((typeof secure === 'boolean' ? secure : this.secure) &&
                this.securityWorker &&
                (yield this.securityWorker(this.securityData))) ||
                {};
            const requestParams = this.mergeRequestParams(params, secureParams);
            const responseFormat = (format && this.format) || void 0;
            if (type === FecContentType.FormData && body && body !== null && typeof body === 'object') {
                requestParams.headers.common = { Accept: '*/*' };
                requestParams.headers.post = {};
                requestParams.headers.put = {};
                body = this.createFormData(body);
            }
            return this.instance.request(Object.assign(Object.assign({}, requestParams), { headers: Object.assign(Object.assign({}, (type && type !== FecContentType.FormData ? { 'Content-Type': type } : {})), (requestParams.headers || {})), params: query, responseType: responseFormat, data: body, url: path }));
        });
        this.instance = axios_1.default.create(Object.assign(Object.assign({}, axiosConfig), { baseURL: utils_1.Environment.getEnvironmentUrl(axiosConfig.baseURL || 'https://subscriptions.api.legalshield.com'), validateStatus: (status) => {
                return status >= 200 && status < 500;
            } }));
        this.secure = secure;
        this.format = format;
        this.securityWorker = securityWorker;
    }
    mergeRequestParams(params1, params2) {
        return Object.assign(Object.assign(Object.assign(Object.assign({}, this.instance.defaults), params1), (params2 || {})), { headers: Object.assign(Object.assign(Object.assign({}, (this.instance.defaults.headers || {})), (params1.headers || {})), ((params2 && params2.headers) || {})) });
    }
    createFormData(input) {
        return Object.keys(input || {}).reduce((formData, key) => {
            const property = input[key];
            formData.append(key, property instanceof Blob
                ? property
                : typeof property === 'object' && property !== null
                    ? JSON.stringify(property)
                    : `${property}`);
            return formData;
        }, new FormData());
    }
}
exports.HttpClient = HttpClient;
/**
 * @title Subscriptions API
 * @version v1
 * @baseUrl https://subscriptions.api.legalshield.com
 */
class Api extends HttpClient {
    constructor() {
        super(...arguments);
        this.v1 = {
            /**
             * No description
             *
             * @tags GroupSubscriptions
             * @name GroupSubscriptionsCancelSubscriptionByGroup
             * @request POST:/v1/groups/{groupId}/identities/{identityId}/subscriptions/{subscriptionId}/cancel
             * @secure
             */
            groupSubscriptionsCancelSubscriptionByGroup: (groupId, identityId, subscriptionId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/groups/${groupId}/identities/${identityId}/subscriptions/${subscriptionId}/cancel`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags GroupSubscriptions
             * @name GroupSubscriptionsPendingCancelSubscriptionByGroup
             * @request POST:/v1/groups/{groupId}/identities/{identityId}/subscriptions/{subscriptionId}/pendingCancel
             * @secure
             */
            groupSubscriptionsPendingCancelSubscriptionByGroup: (groupId, identityId, subscriptionId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/groups/${groupId}/identities/${identityId}/subscriptions/${subscriptionId}/pendingCancel`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags GroupSubscriptions
             * @name GroupSubscriptionsRemovePendingCancelSubscriptionByGroup
             * @request POST:/v1/groups/{groupId}/identities/{identityId}/subscriptions/{subscriptionId}/removePendingCancel
             * @secure
             */
            groupSubscriptionsRemovePendingCancelSubscriptionByGroup: (groupId, identityId, subscriptionId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/groups/${groupId}/identities/${identityId}/subscriptions/${subscriptionId}/removePendingCancel`, method: 'POST', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Subscriptions
             * @name SubscriptionsCreateSubscription
             * @request POST:/v1/identities/{identityId}/subscriptions
             * @secure
             */
            subscriptionsCreateSubscription: (identityId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/subscriptions`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Subscriptions
             * @name SubscriptionsGetSubscriptions
             * @request GET:/v1/identities/{identityId}/subscriptions
             * @secure
             */
            subscriptionsGetSubscriptions: (identityId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/subscriptions`, method: 'GET', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Subscriptions
             * @name SubscriptionsGetSubscription
             * @request GET:/v1/identities/{identityId}/subscriptions/{subscriptionId}
             * @secure
             */
            subscriptionsGetSubscription: (identityId, subscriptionId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/subscriptions/${subscriptionId}`, method: 'GET', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Subscriptions
             * @name SubscriptionsDeleteSubscription
             * @request DELETE:/v1/identities/{identityId}/subscriptions/{subscriptionId}
             * @secure
             */
            subscriptionsDeleteSubscription: (identityId, subscriptionId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/subscriptions/${subscriptionId}`, method: 'DELETE', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Subscriptions
             * @name SubscriptionsUpdateOffers
             * @request POST:/v1/identities/{identityId}/subscriptions/{subscriptionId}/updateOffer
             * @secure
             */
            subscriptionsUpdateOffers: (identityId, subscriptionId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/subscriptions/${subscriptionId}/updateOffer`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Subscriptions
             * @name SubscriptionsCancelSubscription
             * @request POST:/v1/identities/{identityId}/subscriptions/{subscriptionId}/cancel
             * @secure
             */
            subscriptionsCancelSubscription: (identityId, subscriptionId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/subscriptions/${subscriptionId}/cancel`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Subscriptions
             * @name SubscriptionsSuspendSubscription
             * @request POST:/v1/identities/{identityId}/subscriptions/{subscriptionId}/suspend
             * @secure
             */
            subscriptionsSuspendSubscription: (identityId, subscriptionId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/subscriptions/${subscriptionId}/suspend`, method: 'POST', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Subscriptions
             * @name SubscriptionsActivateSubscription
             * @request POST:/v1/identities/{identityId}/subscriptions/{subscriptionId}/activate
             * @secure
             */
            subscriptionsActivateSubscription: (identityId, subscriptionId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/subscriptions/${subscriptionId}/activate`, method: 'POST', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Subscriptions
             * @name SubscriptionsPreCancelSubscription
             * @request POST:/v1/identities/{identityId}/subscriptions/{subscriptionId}/preCancel
             * @secure
             */
            subscriptionsPreCancelSubscription: (identityId, subscriptionId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/subscriptions/${subscriptionId}/preCancel`, method: 'POST', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Subscriptions
             * @name SubscriptionsPendingCancelSubscription
             * @request POST:/v1/identities/{identityId}/subscriptions/{subscriptionId}/pendingCancel
             * @secure
             */
            subscriptionsPendingCancelSubscription: (identityId, subscriptionId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/subscriptions/${subscriptionId}/pendingCancel`, method: 'POST', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Subscriptions
             * @name SubscriptionsAdvanceNextBillOn
             * @request POST:/v1/identities/{identityId}/subscriptions/{subscriptionId}/advanceNextBillOn
             * @secure
             */
            subscriptionsAdvanceNextBillOn: (identityId, subscriptionId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/subscriptions/${subscriptionId}/advanceNextBillOn`, method: 'POST', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Subscriptions
             * @name SubscriptionsUpdatePaymentMethod
             * @request POST:/v1/identities/{identityId}/subscriptions/{subscriptionId}/updatePaymentMethod
             * @secure
             */
            subscriptionsUpdatePaymentMethod: (identityId, subscriptionId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/subscriptions/${subscriptionId}/updatePaymentMethod`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Subscriptions
             * @name SubscriptionsUpdateVendor
             * @request POST:/v1/identities/{identityId}/subscriptions/{subscriptionId}/updateVendor
             * @secure
             */
            subscriptionsUpdateVendor: (identityId, subscriptionId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/subscriptions/${subscriptionId}/updateVendor`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Subscriptions
             * @name SubscriptionsUpdateIdempotentKey
             * @request POST:/v1/identities/{identityId}/subscriptions/{subscriptionId}/updateIdempotentKey
             * @secure
             */
            subscriptionsUpdateIdempotentKey: (identityId, subscriptionId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/subscriptions/${subscriptionId}/updateIdempotentKey`, method: 'POST', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Subscriptions
             * @name SubscriptionsChangeOwner
             * @request POST:/v1/identities/{identityId}/subscriptions/{subscriptionId}/changeOwner
             * @secure
             */
            subscriptionsChangeOwner: (identityId, subscriptionId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/subscriptions/${subscriptionId}/changeOwner`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Subscriptions
             * @name SubscriptionsUpdateDoNotReinstate
             * @request POST:/v1/identities/{identityId}/subscriptions/{subscriptionId}/updateDoNotReinstate
             * @secure
             */
            subscriptionsUpdateDoNotReinstate: (identityId, subscriptionId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/subscriptions/${subscriptionId}/updateDoNotReinstate`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Subscriptions
             * @name SubscriptionsUpdateRetrySchedule
             * @request POST:/v1/identities/{identityId}/subscriptions/{subscriptionId}/updateRetrySchedule
             * @secure
             */
            subscriptionsUpdateRetrySchedule: (identityId, subscriptionId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/subscriptions/${subscriptionId}/updateRetrySchedule`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Subscriptions
             * @name SubscriptionsUpdateAdministrativeArea
             * @request POST:/v1/identities/{identityId}/subscriptions/{subscriptionId}/updateAdministrativeArea
             * @secure
             */
            subscriptionsUpdateAdministrativeArea: (identityId, subscriptionId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/subscriptions/${subscriptionId}/updateAdministrativeArea`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Subscriptions
             * @name SubscriptionsUpdateNextBillOn
             * @request POST:/v1/identities/{identityId}/subscriptions/{subscriptionId}/updateNextBillOn
             * @secure
             */
            subscriptionsUpdateNextBillOn: (identityId, subscriptionId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/subscriptions/${subscriptionId}/updateNextBillOn`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Subscriptions
             * @name SubscriptionsUpdatePostalCode
             * @request POST:/v1/identities/{identityId}/subscriptions/{subscriptionId}/updatePostalCode
             * @secure
             */
            subscriptionsUpdatePostalCode: (identityId, subscriptionId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/subscriptions/${subscriptionId}/updatePostalCode`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Subscriptions
             * @name SubscriptionsUpdateSource
             * @request POST:/v1/identities/{identityId}/subscriptions/{subscriptionId}/updateSource
             * @secure
             */
            subscriptionsUpdateSource: (identityId, subscriptionId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/subscriptions/${subscriptionId}/updateSource`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Subscriptions
             * @name SubscriptionsUpdateStartedOn
             * @request POST:/v1/identities/{identityId}/subscriptions/{subscriptionId}/updateStartedOn
             * @secure
             */
            subscriptionsUpdateStartedOn: (identityId, subscriptionId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/subscriptions/${subscriptionId}/updateStartedOn`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Subscriptions
             * @name SubscriptionsUpdateBillingFrequency
             * @request POST:/v1/identities/{identityId}/subscriptions/{subscriptionId}/updateBillingFrequency
             * @secure
             */
            subscriptionsUpdateBillingFrequency: (identityId, subscriptionId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/subscriptions/${subscriptionId}/updateBillingFrequency`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Subscriptions
             * @name SubscriptionsUpdateBillCycleDay
             * @request POST:/v1/identities/{identityId}/subscriptions/{subscriptionId}/updateBillCycleDay
             * @secure
             */
            subscriptionsUpdateBillCycleDay: (identityId, subscriptionId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/subscriptions/${subscriptionId}/updateBillCycleDay`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Subscriptions
             * @name SubscriptionsGetOutstandingInvoices
             * @request GET:/v1/identities/{identityId}/subscriptions/{subscriptionId}/outstandingInvoices
             * @secure
             */
            subscriptionsGetOutstandingInvoices: (identityId, subscriptionId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/subscriptions/${subscriptionId}/outstandingInvoices`, method: 'GET', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Subscriptions
             * @name SubscriptionsCatchUp
             * @request POST:/v1/identities/{identityId}/subscriptions/{subscriptionId}/catchUp
             * @secure
             */
            subscriptionsCatchUp: (identityId, subscriptionId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/subscriptions/${subscriptionId}/catchUp`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Subscriptions
             * @name SubscriptionsUpdateBillingDivision
             * @request POST:/v1/identities/{identityId}/subscriptions/{subscriptionId}/updateBillingDivision
             * @secure
             */
            subscriptionsUpdateBillingDivision: (identityId, subscriptionId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/subscriptions/${subscriptionId}/updateBillingDivision`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * @description The journal is for internal use only
             *
             * @tags SubscriptionsJournal
             * @name SubscriptionJournal
             * @summary Machine JWT Only
             * @request GET:/v1/subscriptions/journal
             * @secure
             */
            subscriptionJournal: (query, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/subscriptions/journal`, method: 'GET', query: query, secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags SubscriptionsJournal
             * @name SubscriptionsJournalGetJournalMaxClock
             * @request GET:/v1/subscriptions/journal/maxClock
             * @secure
             */
            subscriptionsJournalGetJournalMaxClock: (params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/subscriptions/journal/maxClock`, method: 'GET', secure: true, format: 'json' }, params)),
        };
    }
}
exports.Api = Api;
//# sourceMappingURL=subscriptions.js.map